import { Link } from "react-router-dom";
import { Database, ChevronRight } from "lucide-react";
import scrudConfig from "@/config/adminCrudConfig.json";
import { PageHeader } from "@/components/DashboardLayout";

export default function DataTables() {
    return (
        <>
            <PageHeader
                eyebrow="Admin · SCRUD"
                title="Data tables"
                description={`Search, create, read, update and delete records across all ${scrudConfig.length} registered application tables. Long text fields use a rich-text editor.`}
                testid="datatables-header"
            />

            <div className="px-6 lg:px-12 py-8">
                <div
                    data-testid="scrud-index-grid"
                    className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5"
                >
                    {scrudConfig.map((c) => {
                        const wysiwygFields = c.columns.filter(
                            (col) => col.inputType === "wysiwyg"
                        );
                        return (
                            <Link
                                key={c.routePath}
                                to={`/admin/data/${c.routePath}`}
                                data-testid={`scrud-index-${c.routePath}`}
                                className="group rounded-2xl bg-white shadow-soft p-6 hover:shadow-lift transition-[transform,box-shadow] duration-300 hover:-translate-y-1"
                            >
                                <div className="flex items-start justify-between gap-3 mb-4">
                                    <div className="h-10 w-10 rounded-lg bg-gold-500/10 text-gold-700 flex items-center justify-center">
                                        <Database size={18} strokeWidth={1.7} />
                                    </div>
                                    <ChevronRight
                                        size={18}
                                        className="text-navy-500 group-hover:text-gold-600 transition-colors"
                                    />
                                </div>
                                <div className="font-display text-lg text-navy-700 mb-1 leading-tight">
                                    {c.entityName}
                                </div>
                                <div className="text-xs text-navy-500 font-mono truncate mb-3">
                                    {c.tableName}
                                </div>
                                <div className="flex items-center gap-3 text-xs text-navy-500 flex-wrap">
                                    <span>{c.columns.length} cols</span>
                                    <span className="h-1 w-1 rounded-full bg-navy-500/40" />
                                    <span>PK · {c.primaryKey}</span>
                                    {wysiwygFields.length > 0 && (
                                        <>
                                            <span className="h-1 w-1 rounded-full bg-navy-500/40" />
                                            <span className="text-gold-600">
                                                {wysiwygFields.length} rich-text
                                            </span>
                                        </>
                                    )}
                                    {c.readOnly && (
                                        <span className="ml-auto inline-flex items-center rounded-full bg-navy-700 text-white text-[10px] uppercase tracking-widest font-semibold px-2 py-0.5">
                                            Read-only
                                        </span>
                                    )}
                                </div>
                            </Link>
                        );
                    })}
                </div>
            </div>
        </>
    );
}
